exports = module.exports = require("../../../../web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports
exports.locals = {
	"youtube": "\"900\"",
	"wrong": "\"901\"",
	"van": "\"922\"",
	"user": "\"903\"",
	"twitter": "\"923\"",
	"trash": "\"925\"",
	"time": "\"906\"",
	"search": "\"907\"",
	"price": "\"928\"",
	"pin": "\"929\"",
	"payment-with-change": "\"92a\"",
	"payment-visa": "\"92b\"",
	"payment-mastercard": "\"92c\"",
	"payment-cash": "\"92d\"",
	"payment-card": "\"92e\"",
	"notification": "\"90f\"",
	"moto": "\"92f\"",
	"loggi": "\"931\"",
	"list": "\"912\"",
	"linkedin": "\"913\"",
	"gift": "\"932\"",
	"facebook": "\"933\"",
	"edit": "\"934\"",
	"down": "\"935\"",
	"alert": "\"936\"",
	"circle-arrow-down": "\"938\"",
	"check": "\"939\"",
	"change-order": "\"93a\"",
	"bike": "\"91c\"",
	"baloon": "\"93d\"",
	"back": "\"93f\"",
	"apple": "\"940\"",
	"android": "\"941\"",
	"circle-arrow-left": "\"942\"",
	"add": "\"943\"",
	"shop": "\"944\"",
	"delivery": "\"924\"",
	"bill": "\"945\"",
	"bill-loading": "\"926\"",
	"bill-success": "\"927\"",
	"circle-arrow-right": "\"946\"",
	"deliveries": "\"947\"",
	"arrow-forward": "\"948\"",
	"arrow-two-way": "\"949\"",
	"store-machine": "\"94a\"",
	"checkbook": "\"94b\"",
	"payment-online": "\"94c\"",
	"arrow-down": "\"94d\"",
	"tree-stripes": "\"930\"",
	"override-arrow-left": "\"94e\"",
	"star": "\"94f\"",
	"company": "\"950\"",
	"consolidation": "\"951\"",
	"document": "\"952\"",
	"incidents": "\"953\"",
	"left": "\"95a\"",
	"right": "\"95b\"",
	"up": "\"95c\"",
	"arrow-down-underline": "\"95d\"",
	"stacked-square-plus": "\"95e\"",
	"package": "\"937\"",
	"scissor": "\"954\"",
	"set-square": "\"955\"",
	"circle-arrow-up": "\"956\"",
	"confirmation": "\"93b\"",
	"delete": "\"93c\"",
	"info": "\"957\"",
	"plus": "\"93e\"",
	"coupon": "\"958\"",
	"settings": "\"959\"",
	"arrow-up": "\"902\"",
	"bar-code": "\"905\"",
	"box": "\"909\"",
	"counter-clockwise": "\"90e\"",
	"email-send": "\"910\"",
	"email": "\"911\"",
	"envelope": "\"914\"",
	"messenger": "\"919\"",
	"payment-amex": "\"91a\"",
	"payment-dinners": "\"91b\"",
	"short-arrow-down": "\"91d\"",
	"short-arrow-left": "\"91f\"",
	"short-arrow-right": "\"91e\"",
	"short-arrow-up": "\"920\"",
	"whatsapp": "\"921\"",
	"circle": "\"904\"",
	"clock": "\"908\"",
	"full-circle": "\"90a\"",
	"payment-elo": "\"90b\"",
	"payment-sodexo": "\"90c\"",
	"payment-ticket": "\"90d\"",
	"payment-vr": "\"915\"",
	"three-fourths-circle": "\"916\"",
	"location": "\"917\"",
	"print": "\"918\"",
	"question": "\"95f\"",
	"megaphone": "\"960\"",
	"circle-dash": "\"961\"",
	"picture": "\"962\"",
	"gallery": "\"965\"",
	"redo-arrow": "\"964\"",
	"camera": "\"963\"",
	"lamp": "\"966\"",
	"payment-null": "\"967\"",
	"home": "\"968\"",
	"bullet-list": "\"969\"",
	"bag": "\"96a\"",
	"waves": "\"96b\"",
	"warehouse": "\"96c\"",
	"truck": "\"96d\"",
	"trolley": "\"96e\"",
	"shelf": "\"96f\"",
	"pack-list": "\"970\"",
	"pack-hand": "\"971\"",
	"map-zone": "\"972\"",
	"tag-plus": "\"973\"",
	"circle-tree-points": "\"974\"",
	"play": "\"975\"",
	"globe": "\"976\"",
	"playstore": "\"977\"",
	"calendar": "\"978\"",
	"phone": "\"979\"",
	"residential-building": "\"97a\"",
	"gps-arrow": "\"97b\"",
	"helmet": "\"97c\"",
	"clock-outline": "\"97d\"",
	"payment-paypal": "\"97e\"",
	"payment-wallet": "\"97f\"",
	"eye-blocked": "\"980\"",
	"eye": "\"981\"",
	"minus": "\"982\"",
	"package-beyond": "\"983\""
};